/**
 * Rarity palette and labels (WoW-style quality colours, tuned for dark translucent panels).
 * The progression model has common / rare / epic / legendary; `uncommon` is here for UI parity
 * (green) and for future drops, so every screen can use one map.
 */
import type { Rarity } from '@keystone/progression';

export type UiRarity = Rarity | 'uncommon';

export const RARITY_ORDER: readonly UiRarity[] = ['common', 'uncommon', 'rare', 'epic', 'legendary'];

export const RARITY_COLOR: Readonly<Record<UiRarity, string>> = {
  common: '#a8adb7',
  uncommon: '#3ddc5a',
  rare: '#3b8cff',
  epic: '#b24cf0',
  legendary: '#ff8a1c',
};

export const RARITY_LABEL: Readonly<Record<UiRarity, string>> = {
  common: 'Common',
  uncommon: 'Uncommon',
  rare: 'Rare',
  epic: 'Epic',
  legendary: 'Legendary',
};

export function rarityColor(r: UiRarity | undefined | null): string {
  return (r && RARITY_COLOR[r]) || RARITY_COLOR.common;
}

/** Sets `--rarity` (and the `data-rarity` attribute for CSS hooks) on an element. */
export function applyRarity(el: HTMLElement, r: UiRarity | undefined | null): void {
  const rr = r ?? 'common';
  el.style.setProperty('--rarity', rarityColor(rr));
  el.dataset['rarity'] = rr;
}
